export default __webpack_public_path__ + "static/media/CapaCreateGroupBlue.42ec23f5.svg";